import { render, staticRenderFns } from "./month-closed-tag.vue?vue&type=template&id=2c8bf9e4&"
import script from "./month-closed-tag.vue?vue&type=script&lang=js&"
export * from "./month-closed-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports